import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { useFestivalContext } from '../../context/festival';

const FestivalList = () => {
  const { festival, loading, error } = useFestivalContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const indexOfLastHoliday = currentPage * rowsPerPage;
  const indexOfFirstHoliday = indexOfLastHoliday - rowsPerPage;
  const currentHolidays = festival.slice(indexOfFirstHoliday, indexOfLastHoliday);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  };

  if (loading) {
    return <div>Loading holidays...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const columns = [
    {
      name: 'Festival Name',
      selector: (row) => row.summary,
      sortable: true,
    },
  ];

  return (
    <div>
      <div className='flex items-center justify-between border-b px-4 pb-2'>
        <h1 className='text-2xl'>Indian Festivals</h1>
      </div>

      <DataTable
        columns={columns}
        data={currentHolidays}
        pagination
        paginationServer
        paginationTotalRows={festival.length}
        paginationPerPage={rowsPerPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationRowsPerPageOptions={[10, 20, 30]}
      />
    </div>
  );
};

export default FestivalList;
